import { Box } from '@mui/material';
import { useState } from 'react';
import UserAvatar from './UserAvatar';
import UserMenu from './UserMenu';

const UserAvatarWithMenu = () => {
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);

  const toggleUserMenu = () => {
    setIsUserMenuOpen((prev) => !prev);
  };

  return (
    <Box
      sx={{
        gap: '16px',
        marginLeft: { mobile: 'auto', tablet: 'auto', desktop: 0 },
        marginTop: { mobile: 0, tablet: 0, desktop: '20px' },
      }}
    >
      <UserAvatar onClick={toggleUserMenu} />
      <UserMenu isOpen={isUserMenuOpen} setIsOpen={setIsUserMenuOpen} />
    </Box>
  );
};

export default UserAvatarWithMenu;
